import { ValueObject, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class CreateRawGenericExportMappingCommand extends ValueObject {
    public staticExportColumnSpecId: number = 0;

    public staticServiceProviderFileGroupingId: number = 0;

    public displayName: string = "";

    public isExcluded: boolean = false;
}